import * as React from 'react';
import { NavLink } from 'react-router-dom';
const classNames = require('classnames');
import { SecurityRoles as roles } from '../../common/utils';

import NavItem from './NavItem';
import { IconChevronDown } from '../icons';

interface Props {
	className?: string;
	togglerTo: string;
	togglerClassName?: string;
	togglerChildren: {};
	items: Array<any>;
	rolesRequired?: Array<roles>;
	currentRoles?: Array<roles>;
}
interface State {
	isOpen: boolean;
	isFocused: boolean;
}
class NavFlyout extends React.Component<Props, State> {
	isAuthorized = 
		!Array.isArray(this.props.rolesRequired) ||
		this.props.rolesRequired.length === 0 ||
		this.props.rolesRequired.some(role => 
			Array.isArray(this.props.currentRoles) 
			&& this.props.currentRoles.indexOf(role) >= 0
	);

	constructor(props: Props) {
		super(props);
		this.state = {
			isOpen: false,
			isFocused: false
		};
	}

	onLinkFocus = (e: any) => {
		const currentEl = e.target;
		if (currentEl && currentEl.dataset.flyout === 'nav-flyout') {
			this.setState({ isFocused: true });
			this.handleOpen();
		}
	}
	onLinkBlur = (e: any) => {
		const relatedEl = e.relatedTarget;
		if (!relatedEl || relatedEl.dataset.flyout !== 'nav-flyout') {
			this.setState({ isFocused: false });
			this.handleClose();
		}
	}
	onLinkClick = (e: any, callback?: (e?: any) => any) => {
		this.handleClose();
		if (callback) {
			callback(e);
		}
	}

	onMouseEnter = () => {
		this.handleOpen();
	}
	onMouseLeave = () => {
		if (!this.state.isFocused) {
			this.handleClose();
		}
	}

	handleOpen = () => {
		this.setState({ isOpen: true });
	}
	handleClose = () => {
		this.setState({ isOpen: false });
	}

	render() {
		const { className, items, togglerTo, togglerClassName, togglerChildren } = this.props;

		return this.isAuthorized ? (
			<li
				className={classNames('nav-item nav-flyout', className, { active: this.state.isOpen })}
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
			>
				<div className="navbar-nav-separator">
					<div className="nav-item">
						<NavLink
							className={classNames('nav-flyout-toggler nav-link', togglerClassName)}
							to={togglerTo}
							onFocus={e => this.onLinkFocus(e)}
							onBlur={e => this.onLinkBlur(e)}
							data-flyout="nav-flyout"
						>
							<span className="nav-link-label">{togglerChildren}</span>
							<IconChevronDown className="nav-flyout-toggler-icon" />
						</NavLink>
					</div>
					<div className="nav-flyout-menu" aria-expanded={this.state.isOpen}>
						<ul className="list-unstyled">
							{items.map((item, index) => (
								<NavItem
									className={item.className}
									to={item.to}
									onClick={e => this.onLinkClick(e, item.onClick)}
									onFocus={e => this.onLinkFocus(e)}
									onBlur={e => this.onLinkBlur(e)}
									key={index}
									linkDataFlyout="nav-flyout"
									rolesRequired={item.rolesRequired}
									currentRoles={item.currentRoles}
								>
									{item.label}
								</NavItem>
							))}
						</ul>
					</div>
				</div>
			</li>
		) : null;
	}
}

export default NavFlyout;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/navigation/NavFlyout.tsx